import Comparison from '@/types/comparison';
import ComparisonItem from '@/types/comparison-item';
import IncomeStreamScenario from '@/types/income-stream-scenario';
import ReducedComparison from '@/types/reduced-comparison';
import PERIOD_END_DATA_OPTIONS from '@/types/period-end-data-options';

export enum ComparisonItemsFilter {
  All = 'ALL',
  Products = 'PRODUCTS',
  Groups = 'GROUPS',
}

export enum ComparisonItemCategory {
  CURRENT = 'current',
  RECOMMENDED = 'recommended',
}

export type ComparisonsListState = {
  list: ReducedComparison[];
  nextToken?: string;
};

export type ComparisonLoadingState = {
  isLoading: boolean;
  monthEndDataOption?: PERIOD_END_DATA_OPTIONS;
};

export type ComparisonState = {
  comparisons: {
    recent: ComparisonsListState;
    assigned: ComparisonsListState;
    drafts: ComparisonsListState;
    compliance: ComparisonsListState;
  };
  loading: ComparisonLoadingState;
  activeComparison?: Comparison;
  selectedComparisonItems: ComparisonItem[];
  skipEmptyState: boolean;
  editedScenario?: IncomeStreamScenario;
  householdId?: string;
  householdName?: string;
  isSaving: boolean;
  isFocused: boolean;
  shouldUpdateCommonInception: boolean;
  showLoadClientPortfoliosModal: boolean;
  portfolioEditor: {
    isVisible: boolean;
    isPinned: boolean;
    isReadOnly: boolean;
  };
  tab?: string;
  forcedMonthlyData: boolean;
  itemsFilter: string[];
  originPath?: Location;
};
